module.exports = __webpack_public_path__ + "img/IMG-20200902-WA0009.1af076d6.jpg";